import { PayloadAction } from "@reduxjs/toolkit";
import { AxiosResponse } from "axios";
import { call, put } from "redux-saga/effects";
import {
  successChatbotPublic,
  failureChatbotPublic,
} from "./ChatbotPublicSlicer";
import { IChatbotPublic } from "../../../Components/ChatbotPublic/IChatbotPublic";
import api from "../../Axios/middleware";

import {
  failureReadChatbotPublic,
  successReadChatbotPublic,
} from "./ReadChatbotPublicSlicer";
import {
  failureWritingChatbotPublic,
  successWritingChatbotPublic,
} from "./WritingChatbotPublicSlicer";
import {
  failureExamReadChatbotPublic,
  successExamReadChatbotPublic,
} from "./ExamReadChatbotPublicSlicer";
import {
  failureExamWritingChatbotPublic,
  successExamWritingChatbotPublic,
} from "./ExamWritingChatbotPublicSlicer";

const ChatbotPublicApi = (action: PayloadAction<IChatbotPublic>) => {
  return api.post("/api/ai/chat", action.payload);
};

export function* ChatbotPublicCall(action: PayloadAction<IChatbotPublic>) {
  try {
    const respons: AxiosResponse = yield call(ChatbotPublicApi, action);
    yield put(successChatbotPublic(respons.data));
  } catch (error) {
    yield put(failureChatbotPublic(error));
  }
}

const WritingChatbotPublicApi = (action: PayloadAction<IChatbotPublic>) => {
  return api.post("/api/exam/review-ai-writing", action.payload);
};

export function* WritingChatbotPublicCall(
  action: PayloadAction<IChatbotPublic>
) {
  try {
    const respons: AxiosResponse = yield call(WritingChatbotPublicApi, action);
    yield put(successWritingChatbotPublic(respons.data));
  } catch (error) {
    yield put(failureWritingChatbotPublic(error));
  }
}

const ReadChatbotPublicApi = (action: PayloadAction<IChatbotPublic>) => {
  return api.post("/api/exam/review-ai-reading", action.payload);
};

export function* ReadChatbotPublicCall(action: PayloadAction<IChatbotPublic>) {
  try {
    const respons: AxiosResponse = yield call(ReadChatbotPublicApi, action);
    yield put(successReadChatbotPublic(respons.data));
  } catch (error) {
    yield put(failureReadChatbotPublic(error));
  }
}

const ExamWritingChatbotPublicApi = (action: PayloadAction<IChatbotPublic>) => {
  return api.post("/api/exam/review_ai_exam_writing", action.payload);
};

export function* ExamWritingChatbotPublicCall(
  action: PayloadAction<IChatbotPublic>
) {
  try {
    const respons: AxiosResponse = yield call(
      ExamWritingChatbotPublicApi,
      action
    );
    yield put(successExamWritingChatbotPublic(respons.data));
  } catch (error) {
    yield put(failureExamWritingChatbotPublic(error));
  }
}

const ExamReadChatbotPublicApi = (action: PayloadAction<IChatbotPublic>) => {
  return api.post("/api/exam/review_ai_exam_reading", action.payload);
};

export function* ExamReadChatbotPublicCall(
  action: PayloadAction<IChatbotPublic>
) {
  try {
    const respons: AxiosResponse = yield call(ExamReadChatbotPublicApi, action);
    yield put(successExamReadChatbotPublic(respons.data));
  } catch (error) {
    yield put(failureExamReadChatbotPublic(error));
  }
}
